import { UcoastEl } from '@/scripts/core/UcoastEl'

export class IngredientsList extends UcoastEl {
	static htmlSelector = 'ingredients-list'

	private ingredients: NodeListOf<HTMLElement>

	constructor() {
		super()

		this.ingredients = this.querySelectorAll<HTMLElement>('.ingredient')

		this.ingredients.forEach((ingredient) => {
			ingredient.addEventListener('click', () => {
				this.ingredients.forEach((item) => {
					item.classList.remove('is-selected')
				})

				ingredient.classList.add('is-selected')
			})
		})
	}
}